import React, { useContext } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import { THEME_UPDATE_MESSAGE, ThemeNo } from "../../../../constant";
import StepsContext from "../../../context/StepsContext/StepsContext";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import { TostMessage } from "../../../utils";
import { putUpdateSteps } from "../apis/StepsApi/StepsApi";
import { StepsStyleOneReset, StepsStyleTwoReset } from "./StepsStyleFunction";
import StepsThemeOne from "./StepsThemeOne";
import ThemeImageShow from "../../../common/ThemeImageShow";
import StepsTheme1 from "../ScreenShorts/Steps/StepsTheme1.png";
import StepsTheme2 from "../ScreenShorts/Steps/StepsTheme2.png";
import StepsThemeTwo from "./StepsThemeTwo";

const SettingStepsParentPopup = (props) => {
  const {
    isEdit,
    setSettingFormData,
    setBackImageToggle,
    setBoxSection,
    setIsBackgroundColor,
    imgShow,
    setImgShow,
    theme,
    setTheme,
    id,
  } = useContext(StepsContext);
  const { imageUpload, handleSubmitSetting, handleChangeSettings } = props;
  const { setLoaderShow } = useContext(LoaderContext);
  const handleTheme = async (e) => {
    setLoaderShow(true);
    const { value } = e.target;
    setTheme(value);
    try {
      let formData = {
        theme: value,
        stepId: id,
      };
      const { data } = await putUpdateSteps(formData);
      if (data.status === 200) {
        await handleChangeSettings(id, true);
        TostMessage({
          message: { message: THEME_UPDATE_MESSAGE },
          type: "success",
        });
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    } finally {
      setLoaderShow(false);
    }
  };
  const resetHandler = () => {
    let setStyle;
    if (theme === ThemeNo.ThemeOne) {
      setStyle = StepsStyleOneReset;
    } else if (theme === ThemeNo.ThemeTwo) {
      setStyle = StepsStyleTwoReset;
    } else {
      setStyle = StepsStyleOneReset;
    }
    setSettingFormData({ ...setStyle });
    setBackImageToggle(false);
    setBoxSection(false);
    setIsBackgroundColor(true);
  };
  const handleClose = () => {
    setImgShow(false);
  };
  const themeImg = {
    1: StepsTheme1,
    2: StepsTheme2,
  };

  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="12">
            <div className="mt-4 d-flex flex-column justify-content-center position-relative">
              <div
                className="d-flex justify-content-between position-sticky"
                style={{ top: "87px", background: "white", zIndex: 999 }}
              >
                <h6>{isEdit ? "Edit" : "Add New"}</h6>
                <div className="d-flex gap-2">
                  <Button onClick={resetHandler}>Reset</Button>
                  <Button onClick={() => handleSubmitSetting(true)}>
                    Restore
                  </Button>
                  <Button
                    onClick={() => handleSubmitSetting(null, false)}
                    color="success"
                  >
                    Save & View
                  </Button>
                </div>
              </div>
              <Row>
                <Col>
                  <label htmlFor="">Theme</label>
                  <select
                    name="theme"
                    id="font-weight"
                    className="form-select"
                    value={theme}
                    onChange={(e) => handleTheme(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    <option value={1}>Theme 1</option>
                    <option value={2}>Theme 2</option>
                  </select>
                </Col>
              </Row>
              {!imgShow && (
                <div>
                  <Button
                    onClick={() => setImgShow(true)}
                    color="primary"
                    className="mt-2"
                  >
                    Show Theme Image
                  </Button>
                </div>
              )}
              {imgShow && (
                <ThemeImageShow
                  themeImg={themeImg[theme]}
                  handleClose={handleClose}
                />
              )}
              {+theme === ThemeNo.ThemeOne && (
                <StepsThemeOne
                  imageUpload={imageUpload}
                  handleSuabmitSetting={handleSubmitSetting}
                />
              )}
              {+theme === ThemeNo.ThemeTwo && (
                <StepsThemeTwo
                  imageUpload={imageUpload}
                  handleSuabmitSetting={handleSubmitSetting}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SettingStepsParentPopup;
